import {Injectable} from '@angular/core';

/**
 * Translations for activity history.
 */
@Injectable()
export class ActivityHistoryTranslationsService {
  public firstName: any = $localize`:@@general.activityHistory.firstName:First name`;
  public lastName: any = $localize`:@@general.activityHistory.lastName:Last name`;
  public salutation: any = $localize`:@@general.activityHistory.salutation:Salutation`;
  public gender: any = $localize`:@@general.activityHistory.gender:Gender`;
  public title: any = $localize`:@@general.activityHistory.title:Title`;
  public birthday: any = $localize`:@@general.activityHistory.birthday:Birthday`;
  public company: any = $localize`:@@general.activityHistory.company:Company`;

  public update: any = $localize`:@@general.activityHistory.update:Update`;
  public insert: any = $localize`:@@general.activityHistory.create:Create`;
  public delete: any = $localize`:@@general.activityHistory.delete:Delete`;
  public customer: any = $localize`:@@general.activityHistory.customer:Customer`;

  public city: any = $localize`:@@general.activityHistory.city:City`;
  public postalCode: any = $localize`:@@general.activityHistory.postalCode:Postal code`;
  public country: any = $localize`:@@general.activityHistory.country:Country`;
  public street: any = $localize`:@@general.activityHistory.street:Street`;
  public type: any = $localize`:@@general.activityHistory.type:Type`;

  public phone: any = $localize`:@@general.activityHistory.phone:Phone`;
  public mobile: any = $localize`:@@general.activityHistory.mobile:Mobile`;
  public email: any = $localize`:@@general.activityHistory.email:Email`;

  public attributeName: any = $localize`:@@general.activityHistory.attributeName:Attribute name`;

  public membershipNumber: any = $localize`:@@general.activityHistory.membershipNumber:Membership number`;

  public comment: any = $localize`:@@general.activityHistory.comment:Comment`;
  public status: any = $localize`:@@general.activityHistory.status:Status`;
  public joinDate: any = $localize`:@@general.activityHistory.joinDate:Join date`;

  public iban: any = $localize`:@@general.activityHistory.iban:IBAN`;
  public bic: any = $localize`:@@general.activityHistory.bic:BIC`;
  public bankName: any = $localize`:@@general.activityHistory.bankName:Bank name`;
  public subscription: any = $localize`:@@general.activityHistory.subscription:Subscription`;
  public subscriptionDate: any = $localize`:@@general.activityHistory.subscriptionDate:Subscription date`;

  public mergedAt: any = $localize`:@@general.activityHistory.mergedDate:Merged date`;
  public sourceCustomerNumber: any = $localize`:@@general.activityHistory.sourceCustomer:Source customer`;
  public targetCustomerNumber: any = $localize`:@@general.activityHistory.targetCustomer:Target customer`;
  public 'state.description': any = $localize`:@@general.activityHistory.stateDescription:State description`;


  public leaveDate: any = $localize`:@@general.activityHistory.leaveDate:Leave date`;
  public subscriptionStatus: any = $localize`:@@general.activityHistory.subscriptionStatus:Permission`;
  /**
   * Error alert messages are listed below
   */
  public i18nErrorFetchingActivityHistory: any = $localize`:@@alertService.alert.error.fetchingActivityHistory:Error occurred. Activity history could not be fetched.`;

  constructor() { }
}
